// Простое хеширование в base64 (для теста)
export const hashPassword = (password) => {
  return password // В реальном проекте используйте библиотеку bcrypt!
};

export const validateUsername = (username) => {
  const regex = /^[a-zA-Z0-9_]{3,20}$/;
  return regex.test(username);
};

// Проверка пароля
export const checkPassword = (inputPassword, savedPassword) => {
  return inputPassword === savedPassword;
};